module.exports = __webpack_public_path__ + "static/LinkedIn-5ffb4cf35eb9a43eba9a1812ea6f4c3a.png";